export default defineNuxtPlugin(() => {
  const gsiScript = document.createElement('script')
  gsiScript.type = 'text/javascript'
  gsiScript.src = 'https://accounts.google.com/gsi/client'
  gsiScript.async = true
  gsiScript.defer = true
  document.head.appendChild(gsiScript)
})
